import React, { FC, useEffect, useState } from 'react';

import { Button, Radio, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { RadioChangeEvent } from 'antd/lib/radio';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CustomInputText } from 'src/components/forms/pin/CustomInputText';
import { IEditPharmacy } from 'src/shared/models/userProfile.model';
import {
  buildRegularParagraph,
  dispatchPageViewEvent,
  virtualUrlInit,
} from 'utils';
import router from 'next/router';

export interface OwnProps {
  filter?: string;
  disabled?: boolean;
  form: FormInstance;
  isSearching: boolean;
  loading?: boolean;
  handleOnChange: (e: RadioChangeEvent) => void;
  handleOnClick: () => void;
  onRestore: () => void;
  pharmacies: IEditPharmacy[];
  pharmaciesFiltered?: IEditPharmacy[];
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  cancelButton: boolean;
}

type Props = OwnProps;

export const PharmacyList: FC<Props> = (props): JSX.Element => {
  const {
    disabled,
    setFilter,
    form,
    isSearching,
    loading,
    pharmacies,
    pharmaciesFiltered,
    handleOnChange,
    handleOnClick,
    onRestore,
    cancelButton,
  } = props;

  const [isErrorVisible, setIsErrorVisible] = useState<boolean>(false);
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

  const listWrapperClassnames: string = classNames('pharmacy__list-wrapper', {
    'double-button': cancelButton,
  });

  useEffect(() => {
    setIsFirstRender(true);
  }, []);

  useEffect(() => {
    setIsFirstRender(true);
    if (pharmaciesFiltered?.length > 0) setIsErrorVisible(false);
  }, [pharmaciesFiltered]);

  const renderErrorZipcodeText = () => {
    if (isFirstRender && !isErrorVisible) {
      dispatchPageViewEvent(router, {
        ...virtualUrlInit,
        section: 'experiences',
        pageType: 'error',
        detail: 'search-pharmacy',
      });

      setIsFirstRender(false);
      setIsErrorVisible(true);
    }

    return (
      <div className="zipCode--search__error">
        <div className="zipCode--search__error-title">
          <FormattedMessage
            id={`form.field.pharmacy.find.sorry${
              pharmacies?.length ? '.filter' : ''
            }`}
          />
        </div>
        <div className="zipCode--search__error-subTitle">
          {buildRegularParagraph(
            `form.field.pharmacy.find.try.again${
              pharmacies?.length ? '.filter' : ''
            }`,
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {pharmacies?.length > 0 && (
        <div className="pharmacy__list-filter">
          {CustomInputText(
            form,
            'FilterPharmacies',
            'form.field.pharmacy.search',
            (e) => setFilter(e.target.value),
            '',
            30,
            false,
          )}
        </div>
      )}
      <Radio.Group
        defaultValue="1"
        className={listWrapperClassnames}
        onChange={handleOnChange}>
        {pharmaciesFiltered?.length > 0
          ? pharmaciesFiltered.map((pharmacy: IEditPharmacy) => {
              return (
                <Radio.Button
                  key={pharmacy.accountName}
                  value={pharmacy.accountName}
                  className="pharmacy__list-card">
                  <p className="pharmacy__list-card--title fs-mask">
                    {pharmacy.accountName}
                  </p>
                  <p className="fs-mask">
                    {pharmacy.street} {pharmacy.streetNumber}
                  </p>
                  <p className="fs-mask">
                    {pharmacy.zipcode} {pharmacy.city}, {pharmacy.regionName}
                  </p>
                  <div className="pharmacy__list-card--selected" />
                </Radio.Button>
              );
            })
          : isSearching && renderErrorZipcodeText()}
      </Radio.Group>
      {pharmaciesFiltered.length > 0 && (
        <div className="pharmacy__list__button">
          <Button
            disabled={disabled}
            loading={loading}
            className="btn-primary btn-primary--black"
            block
            onClick={handleOnClick}
            htmlType="button">
            <div>
              <FormattedMessage id="form.field.pharmacy.save" />
            </div>
          </Button>
          {cancelButton && (
            <Button
              className="btn-primary"
              block
              onClick={onRestore}
              htmlType="button">
              <Row justify="center">
                <FormattedMessage id="button.cancel" />
              </Row>
            </Button>
          )}
        </div>
      )}
    </>
  );
};
